module.exports = __webpack_public_path__ + "cancellara-dist/img/aon.9800f571.png";